import { apiClient } from './client';

export const sitesApi = {
  getAll() {
    return apiClient.get('/sites');
  },

  getById(siteId) {
    return apiClient.get(`/sites/${siteId}`);
  },

  create(data) {
    return apiClient.post('/sites', data);
  },

  update(siteId, data) {
    return apiClient.patch(`/sites/${siteId}`, data);
  },

  delete(siteId) {
    return apiClient.delete(`/sites/${siteId}`);
  },
};
